import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { PaymentGatewaysPageRoutingModule } from './payment-gateways-routing.module';

import { PaymentGatewaysPage } from './payment-gateways.page';
import { MasterHeaderModule } from '../../master-header/master-header.module';
import { MasterFooterModule } from '../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    PaymentGatewaysPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [PaymentGatewaysPage],
})
export class PaymentGatewaysPageModule {}
